function sectionRedering() {
  fetch("?section_id=cart-drawer")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".cart__content-wrap", cart__html);
      $(".cart__content-wrap").replaceWith(render__html);

      var render__html = $(".cart__top-text p", cart__html);
      $(".cart__top-text p").replaceWith(render__html);

      var render__html = $(".cart__announcement", cart__html);
      $(".cart__announcement").replaceWith(render__html);

    });

  // header 
  // header section 
  fetch("?section_id=header")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".header__right-cart span", cart__html);
      $(".header__right-cart span").replaceWith(render__html);
    });

}



function updateVariantImage(variant_featured_img) {
  if (variant_featured_img) {
    $(".product__big-item").each(function () {
      let img__src = $(this).find("img").attr("src");
      if (variant_featured_img === img__src) {
        let index = $(this).closest(".product__big-item").attr("data-slick-index");
        $('.product__big-items').slick('slickGoTo', index);
      }

    })
  }
}

// match variant and update variant id and variant image 
// $(document).ready(function () { 
function selectedVarint() {
  var slectedId = $(".select__variant").val();
  var url = new URL(window.location.href);
  url.searchParams.set("variant", slectedId);
  window.history.replaceState({}, "", url);
}


//   // match variant

function matchVariant() {
  var updateValue = "";
  $(".product__purchase-content-item input[type='radio']:checked").each(function () {

    updateValue += (updateValue ? " / " : "") + $(this).val();
  })

  var isMatchFound = false;
  $(".select__variant option").each(function () {

    var optionValue = $(this).text().trim();

    if (updateValue.toLowerCase() == optionValue.toLowerCase()) {
      isMatchFound = true;
      $(this).prop("selected", true);


      var variant__available = $(this).attr("data-variant-available");

      var variant_featured_img = $(this).attr("data-variant-featured-img");
      // console.log(optionValue);

      // call update variant image function 
      updateVariantImage(variant_featured_img);

      if (variant__available == 'false') {
        $(".product-hero__add-pro").addClass("disabled");
        $(this).addClass("disabled");
      } else {
        $(".product-hero__add-pro").removeClass("disabled");
        $(".product-hero__add-pro").removeClass("disabled");
        $(this).removeClass("disabled");
      }
    }
    return true;

  });
}

$(".product__purchase-content-item input[type='radio']").change(function () {
  matchVariant();
  selectedVarint();
})

$(document).ready(function () {
  matchVariant();
});


$(".product-hero__add-pro").on("click", function (e) {

  e.preventDefault();
  formData = $(this).closest(".single__product-add-pro").serialize();
  addToCart(formData)
})






function increment_p(el) {
  var input = el.previousElementSibling;
  var value = parseInt(input.value);
  value = isNaN(value) ? 0 : value
  value++;
  input.value = value;
  $(".product__quantity-minus").addClass("active");
}

function decrement_p(el) {
  var input = el.nextElementSibling;
  var value = parseInt(input.value);
  if (value > 1) {
    value = isNaN(value) ? 1 : value;
    value--;
    input.value = value;
    if (value == 1) {
      $(".product__quantity-minus").removeClass("active");
    }

  }
}




function addToCart(formData) {
  console.log(formData);
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: formData,
    success: function (data) {
      console.log(data)
      sectionRedering();
      //   $(".cart").addClass("active");
      $("body").addClass("cart-open");

    },
    error: function (err) {
      console.log(err);
    },
  });
}





// increment quantity in cart drawer
function increment(el) {
  var input = el.previousElementSibling;
  var value = parseInt(input.value);
  console.log(value)
  value = isNaN(value) ? 0 : value
  value++;
  input.value = value;
  changeQuantity(input);

}
// decrement quantity in cart drawer
function decrement(el) {
  var input = el.nextElementSibling;
  var value = parseInt(input.value);
  if (value > 0) {
    value = isNaN(value) ? 0 : value;
    value--;
    input.value = value;
    changeQuantity(input);
  }
}

function changeQuantity(input) {

  var quantity = $(input).val();
  var data_line = $(input).attr("data-line");
  var data = {
    "line": data_line,
    "quantity": quantity
  };
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: data,
    success: function (data) {
      console.log(data);
      sectionRedering();
    },
    error: function (err) {
      console.log("Error from quantity update")
    }
  })


}


function removeItem(event, el) {
  event.preventDefault();
  var data_line = $(el).attr("data-line");
  console.log(data_line)
  var deleteData = {
    "line": data_line,
    "quantity": 0
  };

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: deleteData,
    success: function (data) {

      sectionRedering();
    }
  })
}



$(document).ready(function () {
  const $productData = $('#product-data');
  const subVariantId = $productData.attr('data-sub-variant-id');
  const subSellingPlanId = $productData.attr('data-sub-selling-plan-id');

  let hasRunElseOnce = false; // <-- flag for else block

  $(".product__purchase-title").on("click", function () {
    const $form = $(this).closest('form');
    const $variantSelect = $form.find("select[name='id']");
    const $sellingPlanInput = $form.find(".selling__plan-set-value");

    if ($(this).hasClass("product__purchase-subscribe")) {
      $sellingPlanInput.attr("name", "selling_plan");
      $(".product-hero__add-pro").removeClass("disabled");

      var firstImg = $('.select__variant option').eq(0).data('variant-featured-img');
      updateVariantImage(firstImg);
      $variantSelect.val(subVariantId);
      hasRunElseOnce = false;
    } else if (!hasRunElseOnce) {
      hasRunElseOnce = true; 
      $sellingPlanInput.removeAttr("name");
      matchVariant();
    }
  });
});